/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react'; // oxlint-disable-line typescript-eslint/consistent-type-imports -- jsx used via classic JSX pragma
import { Index } from 'react-instantsearch-dom';

import MenuGroup from '@atlaskit/menu/menu-group';
import { Box } from '@atlaskit/primitives';
import { ContextualAnalyticsData, INLINE_DIALOG } from '@atlassian/analytics-bridge';

import PopularResults from './popular-results';
import Results from './results';

type SearchClientProps = {
	onResultClick?(): void;
	testId?: string;
	query: string;
	activeIndex: number;
	onResultsCountChange(count: number): void;
	onSearchingChange?(isSearching: boolean): void;
	listboxId: string;
	statusId?: string;
	resultsCount: number;
	shouldShowDefaultResults?: boolean;
	resultRef?: (index: number) => (el: HTMLAnchorElement | null) => void;
};

export type Indices = 'Foundations' | 'Patterns' | 'Components' | 'Get started' | 'Tokens';

const SearchClient = ({
	onResultClick,
	testId,
	query,
	activeIndex,
	onResultsCountChange,
	onSearchingChange,
	listboxId,
	shouldShowDefaultResults,
	resultRef,
}: SearchClientProps): jsx.JSX.Element => {
	const indices: { name: Indices; title: Indices }[] = [
		{ name: 'Foundations', title: 'Foundations' },
		{ name: 'Patterns', title: 'Patterns' },
		{ name: 'Components', title: 'Components' },
		{ name: 'Get started', title: 'Get started' },
		{ name: 'Tokens', title: 'Tokens' },
	];

	const shouldShowResults = query || shouldShowDefaultResults;

	return (
		<React.Fragment>
			{shouldShowResults ? indices.map(({ name }) => <Index key={name} indexName={name} />) : null}

			<ContextualAnalyticsData sourceType={INLINE_DIALOG} sourceName="search">
				<Box id={listboxId} role="listbox" aria-label="Search results">
					<MenuGroup testId={testId ? `${testId}-results` : undefined} minHeight="100px">
						{shouldShowResults ? (
							<Results
								activeIndex={activeIndex}
								onResultsCountChange={onResultsCountChange}
								onSearchingChange={onSearchingChange}
								onResultClick={onResultClick}
								listboxId={listboxId}
								shouldShowDefaultResults={shouldShowDefaultResults}
								resultRef={resultRef}
							/>
						) : (
							<PopularResults
								activeIndex={activeIndex}
								onResultsCountChange={onResultsCountChange}
								onResultClick={onResultClick}
								listboxId={listboxId}
								resultRef={resultRef}
							/>
						)}
					</MenuGroup>
				</Box>
			</ContextualAnalyticsData>
		</React.Fragment>
	);
};

export default SearchClient;
